import { Components, Palette, PaletteColor, Theme } from '@mui/material';
import { inputBaseClasses } from '@mui/material/InputBase';

export const MuiInputBase = {
  defaultProps: {
    size: 'small',
  },
  styleOverrides: {
    root: ({ theme }) => ({
      '& .MuiInputAdornment-root': {
        color: theme.palette.neutral.onSurfaceVariant,
        //TODO: Refactoring (Olena Shchadylo) SPRINT 196 - Remove height overrides in scope [https://over-haul.atlassian.net/browse/OK-45495]
        height: 'auto',
      },
      '&.Mui-disabled': {
        '& .MuiInputAdornment-root': {
          color: theme.palette.action.disabled,
          '& .MuiSvgIcon-root': {
            color: theme.palette.action.disabled,
          }
        }
      }
    }),
    input: ({ theme }) => ({
      ...theme.typography.body2,
      color: theme.palette.neutral.onSurface,
      borderRadius: 4,
      '&:-webkit-autofill': {
        WebkitBoxShadow: '0 0 0 100px transparent inset!important',
        WebkitTextFillColor: `${theme.palette.neutral.onSurface} !important`,
      },
      '&.Mui-disabled': {
        WebkitTextFillColor: theme.palette.action.disabled,
      }
    }),
    sizeSmall: {
      minHeight: 40,
    },
  }
} as Components<Theme>['MuiInputBase'];

export const MuiTextField = {
  defaultProps: {
    fullWidth: true,
    size: 'small',
    margin: 'normal'
  },
  styleOverrides: {
    root: () => ({
      '&.MuiFormControl-marginNormal': {
        marginBottom: 0,
      }
    }),
  }
} as Components<Theme>['MuiTextField'];

export const MuiInputLabel = {
  defaultProps: {
    color: 'primary'
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      ...theme.typography.body2,
      color: theme.palette.neutral.onSurfaceVariant,
      '&.Mui-disabled': {
        color: theme.palette.action.disabled
      },
      '&.Mui-focused': {
        color: (theme.palette[ownerState.color! as keyof Palette] as PaletteColor).main,
      },
      '&.Mui-error': {
        color: theme.palette.error.main,
      },
    }),
  }
} as Components<Theme>['MuiInputLabel'];

export const MuiOutlinedInput = {
  defaultProps: {
    size: 'small',
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      return {
        borderRadius: 4,
        color: theme.palette.neutral.onSurface,
        borderColor: theme.palette.neutral.outline,
        '&.Mui-disabled': {
          'WebkitTextFillColor': theme.palette.action.disabled,
          color: theme.palette.action.disabled,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.action.disabledBorder,
          },
          '&:hover': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.action.disabledBorder,
            }
          }
        },
        '& .clear-icon': {
          display: 'none',
          cursor: 'pointer',
        },
        '& .error-icon': {
          display: 'none',
          fill: theme.palette.error.main
        },
        '& .MuiOutlinedInput-input': {
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        },
        [`&.${inputBaseClasses.multiline} > .${inputBaseClasses.input}`]: {
          whiteSpace: 'pre-line',
          overflowY: 'auto!important',
        },
        '&.MuiInputBase-multiline': {
          alignItems: 'flex-start',
          '& .clear-icon': {
            display: ownerState.error ? 'none' : 'block',
          },
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.neutral.outline
        },
        '&:hover': {
          '& .clear-icon': {
            display: 'initial',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.neutral.onSurface
          },
        },
        '&.Mui-focused': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette[ownerState.color!].main
          },
        },
        '&.Mui-error': {
          '& .error-icon': {
            display: 'initial',
          },
          '&:hover': {
            '& .clear-icon': {
              display: 'initial',
              '& + .error-icon': {
                display: 'none',
              }
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.error.main
            },
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.error.main,
          },
        },
        '&.MuiInputBase-readOnly': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.neutral.outline,
          },
          '&.Mui-disabled': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.action.disabledBorder,
            },
          },
          '&.Mui-error': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.error.main,
            },
          },
        }
      };
    },
  }
} as Components<Theme>['MuiOutlinedInput'];